import React, { Component } from "react";
import classnames from "classnames";
import styles from "../IndicatorsExplanation/IndicatorsExplanation.local.scss";
import SidePageHeader from "../Common/SidePageHeader/SidePageHeader";
import { setCurrentNavPage, setExplanations } from "Actions";
import {
  fetchIndicatorsExplanation,
  fetchSupportedIndicatorVars,
  deleteIndicatorExplanation,
  saveIndicatorsExplanation
} from "Thunks";
import _ from "i18n";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { SvgIcon } from "../Common/Icons";
import IndicatorExplanationSideBar from "./IndicatorExplanationSideBar";
import {
  onSuccess,
  onError,
  getIndicatorLabel,
  checkIfIndicatorHasExplanation
} from "Utils";
import ItemExplanation from "./ItemExplanation";
import IndicatorExplanationUpdateSideBar from "./IndicatorExplanationUpdateSideBar";
import NotFoundV2 from "../NotFound/NotFoundV2";
import { ModalConfirm } from "tamtam-components";

class IndicatorsExplanationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddingExplanation: false,
      isUpdatingExplanation: false,
      explanations: { fr: "", en: "", nl: "" },
      originalAccount: null,
      selectedAccount: null,
      updateExplanation: [],
      explanationId: null,
      updateAccount: false,
      selectedUpdateAccount: null,
      inputValue: "",
      isOpenModal: false,
      isOpenModalDelete: false
    };
  }
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(setCurrentNavPage("INDICATORS_EXPLANATION"));

    dispatch(fetchIndicatorsExplanation());
    dispatch(fetchSupportedIndicatorVars());
  }

  resetExplanations = () => {
    this.setState({
      explanations: { fr: "", en: "", nl: "" },
      selectedAccount: this.state.originalAccount
    });
  };

  clearInputSearch = () => {
    this.setState({
      inputValue: ""
    });
  };
  onChangeInputSearch = event => {
    this.setState({
      inputValue: event.target.value
    });
  };
  onChangeExplanationFr = event => {
    this.setState({
      explanations: { ...this.state.explanations, fr: event.target.value }
    });
  };

  onChangeExplanationEn = event => {
    this.setState({
      explanations: { ...this.state.explanations, en: event.target.value }
    });
  };

  onChangeExplanationNl = event => {
    this.setState({
      explanations: { ...this.state.explanations, nl: event.target.value }
    });
  };

  onCancelUpdateExplanation = () => {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
    // document.getElementById("mainMenu").style.zIndex = 4;
    document.body.style.removeProperty("overflow");

    this.setState({
      isUpdatingExplanation: false,
      updateAccount: false
    });
  };

  onCancelNewExplanation = () => {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
    // document.getElementById("mainMenu").style.zIndex = 4;
    document.body.style.removeProperty("overflow");

    this.setState({
      isAddingExplanation: false
    });
  };

  onClickUpdateExplanation = explanationId => {
    const { explanationsItems, indicators } = this.props;

    let updatedExplanation = explanationsItems.find(
      obj => obj.id === explanationId
    );
    let selectedIndicator = null;

    indicators &&
      // eslint-disable-next-line array-callback-return
      indicators.map(indicat => {
        if (indicat.code.slice(1) === updatedExplanation.target) {
          const indicator = indicat.code.concat(" : ".concat(indicat.label.fr));
          this.setState({ selectedUpdateAccount: indicat.code.slice(1) });
          selectedIndicator = { label: indicator, value: indicat.code };
        }
      });
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.remove("hide");
    // document.getElementById("mainMenu").style.zIndex = 6;
    document.body.style.overflow = "hidden";

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    this.setState({
      explanationId: updatedExplanation.id,
      explanations: {
        fr: updatedExplanation.content.fr,
        en: updatedExplanation.content.en,
        nl: updatedExplanation.content.nl
      },
      originalLabels: { fr: "", en: "", nl: "" },
      isUpdatingExplanation: true,
      selectedAccount: selectedIndicator
    });
  };

  handleUpdateExplanation = explanationId => {
    const { explanations, selectedAccount } = this.state;
    const { dispatch, explanationsItems } = this.props;
    let updatedExplanation = [...explanationsItems];

    dispatch(
      saveIndicatorsExplanation(
        explanationId,
        selectedAccount.value.slice(1),
        explanations
      )
    ).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("explanationUpdated")
        });

        // eslint-disable-next-line array-callback-return
        updatedExplanation.map((explanation, i) => {
          if (explanation.id === explanationId) {
            updatedExplanation[i].target = selectedAccount.value.slice(1);
            updatedExplanation[i].content = explanations;
          }
        });
        dispatch(setExplanations(updatedExplanation));
        this.onCancelUpdateExplanation();

        this.setState({
          updateAccount: false,
          explanations: { fr: "", en: "", nl: "" },
          originalLabels: [],
          isAddingExplanation: false,
          isUpdatingExplanation: false,
          originalAccount: null,
          selectedAccount: null,
          selectedUpdateAccount: null
        });
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };
  onClickNewExplanation = () => {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.remove("hide");
    // document.getElementById("mainMenu").style.zIndex = 6;
    document.body.style.overflow = "hidden";

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    this.setState({
      explanations: { fr: "", en: "", nl: "" },
      originalLabels: { fr: "", en: "", nl: "" },
      isAddingExplanation: true,
      selectedAccount: null
    });
  };

  handleSaveNewExplanation = () => {
    const { explanations, selectedAccount } = this.state;
    const { dispatch, explanationsItems } = this.props;

    let updatedExplanation = [...explanationsItems];
    if (
      selectedAccount &&
      explanationsItems.find(obj => obj.target === selectedAccount.slice(1))
    ) {
      onError("Compte / indicateur déjà une explication");
    } else {
      dispatch(
        saveIndicatorsExplanation(null, selectedAccount.slice(1), explanations)
      ).then(
        res => {
          onSuccess(res, {
            title: _("saveSuccess"),
            body: _("explanationAdded")
          });
          updatedExplanation.push({
            id: res.value.data.data.IndicatorExplanation.id,
            owner: res.value.data.data.IndicatorExplanation.owner,
            content: explanations,
            target: selectedAccount.slice(1)
          });

          dispatch(setExplanations(updatedExplanation));
          this.onCancelNewExplanation();
        },
        err => {
          onError(err.response.data.errors[0].message);
        }
      );
    }
  };

  onChangeSelectedAccount = selectedAccount => {
    this.setState({
      selectedAccount: selectedAccount ? selectedAccount.value : null
    });
  };

  handleDeleteExplanation = explanationId => {
    this.setState({ explanationId: explanationId });
    this.setState({ isOpenModalDelete: true });
  };

  renderExplanations = Explanations => {
    const { lng, indicators, dispatch, explanationsItems } = this.props;
    let { isOpenModalDelete, explanationId } = this.state;

    return (
      <div className={classnames("row")}>
        {Explanations.map((item, i) => {
          return (
            <div
              key={`created-${i}`}
              className={classnames(
                "columns medium-6 small-6",
                styles.item_div
              )}
            >
              <ItemExplanation
                item={item}
                lng={lng}
                resetExplanations={this.resetExplanations}
                onClickUpdateExplanation={this.onClickUpdateExplanation}
                handleDeleteExplanation={this.handleDeleteExplanation}
                deleting={this.props.deleting}
                indicators={indicators}
                selectedAccount={this.state.selectedAccount}
              />
              <ModalConfirm
                type={"delete"}
                isOpen={isOpenModalDelete}
                onCancel={() => this.setState({ isOpenModalDelete: false })}
                onConfirm={() => {
                  let updatedExplanation = [...explanationsItems];

                  return new Promise((resolve, reject) => {
                    dispatch(deleteIndicatorExplanation(explanationId)).then(
                      res => {
                        onSuccess(res, {
                          title: _("removeSuccess"),
                          body: _("explanationDeleted")
                        });
                        resolve(true);

                        dispatch(
                          setExplanations(
                            updatedExplanation.filter(
                              ({ id }) => id !== explanationId
                            )
                          )
                        );
                        this.setState({ isOpenModalDelete: false });
                      },
                      err => {
                        onError(err.response.data.errors[0].message);
                        reject(true);
                      }
                    );
                  }).catch(() => console.log("Oops errors!"));
                }}
                inProcess={false}
                actionFailed={false}
                title={_("deleteConfirmation")}
                text={_("deleteExplanationContent")}
                labelNo={_("cancel")}
                labelYes={_("Delete")}
                labelError={"Error"}
              />
            </div>
          );
        })}
      </div>
    );
  };
  renderAddBubble = () => {
    const { isAddingExplanation } = this.state;
    return (
      <div className="setting-bubbles">
        <div
          className={classnames(
            "circleSvg",
            isAddingExplanation ? "active opened" : ""
          )}
          onClick={() => this.onClickNewExplanation()}
        >
          <SvgIcon icon={"AddIcon"} />
          <span style={{ paddingLeft: "2.5rem" }}>{_("Add")}</span>
        </div>
      </div>
    );
  };

  handleClosePage = () => {
    this.setState({ isOpenModal: true });
  };
  render() {
    const {
      fetching,
      fetched,
      saving,
      explanationsItems,
      indicators,
      dispatch
    } = this.props;
    const {
      explanationId,
      isAddingExplanation,
      isUpdatingExplanation,
      explanations,
      inputValue,
      isOpenModal
    } = this.state;

    const explanationsSearch =
      indicators &&
      inputValue.length &&
      explanationsItems.filter(
        ({ target }) =>
          getIndicatorLabel(target, indicators).includes(inputValue) === true
      );
    const indicatorsOptionsSelect =
      indicators &&
      indicators.map(indicat => {
        const code =
          indicat.code.slice(0, 3) === "#0_"
            ? indicat.code.slice(3)
            : indicat.code.slice(1);
        const indicator = code.concat(" : ".concat(indicat.label.fr));
        return { label: indicator, value: indicat.code };
      });
    return (
      <div
        className={classnames(styles.indicators_explanation, "page-content")}
      >
        <SidePageHeader
          subHeader={_("manageExplanation")}
          withReturnButton={true}
          handleReturnTo={this.handleClosePage}
        />
        <ModalConfirm
          type={"return"}
          isOpen={isOpenModal}
          onCancel={() => this.setState({ isOpenModal: false })}
          onConfirm={() => {
            dispatch(push("/folders"));
          }}
          inProcess={false}
          actionFailed={false}
          title={_("exitConfirm")}
          text={_("cancelConfirmContent")}
          labelNo={_("cancel")}
          labelYes={_("exit")}
          labelError={"Error"}
        />
        <div className={styles.explanations_block}>
          <div className={styles.title_block}>
            <h2 className={styles.title}>{_("explanationsList")}</h2>
            <h3 className={styles.subtitle}>{_("actionsOnExplinations")}</h3>
          </div>
          <div className={styles.tabs_block}>
            <div
              style={{
                marginBottom: "1%",
                marginLeft: "70%"
              }}
            >
              <div className="search-box">
                <span className="search-box__icon">
                  <img src={"/img/icons/search.svg"} alt={""} />
                </span>
                <input
                  value={inputValue}
                  placeholder={"search"}
                  onChange={this.onChangeInputSearch}
                  onKeyPress={this.handleKeyPress}
                />
                {inputValue &&
                  inputValue.length && (
                    <img
                      className="icomoon icon-tt-close"
                      src="/img/icons/close.svg"
                      alt={""}
                      onClick={this.clearInputSearch}
                    />
                  )}
              </div>
            </div>
          </div>
          <div>
            {fetching && (
              <div className={styles.ripple_loading_adapted}>
                <img src={"/img/Ripple-1s-150px.svg"} alt="" />
              </div>
            )}
            {fetched && this.renderAddBubble()}
            {fetched &&
              this.renderExplanations(
                inputValue.length ? explanationsSearch : explanationsItems
              )}
            {fetched && inputValue.length && explanationsSearch.length < 1 ? (
              <NotFoundV2 />
            ) : (
              ""
            )}
            {fetched && (
              <IndicatorExplanationSideBar
                saving={saving}
                isAddingExplanation={isAddingExplanation}
                explanations={explanations}
                onCancelNewExplanation={this.onCancelNewExplanation}
                onChangeExplanationFr={this.onChangeExplanationFr}
                onChangeExplanationEn={this.onChangeExplanationEn}
                onChangeExplanationNl={this.onChangeExplanationNl}
                handleSaveNewExplanation={this.handleSaveNewExplanation}
                selectedAccount={this.state.selectedAccount}
                onChangeSelectedAccount={this.onChangeSelectedAccount}
                indicators={indicatorsOptionsSelect.filter(
                  ({ value }) =>
                    checkIfIndicatorHasExplanation(
                      value.slice(1),
                      explanationsItems
                    ) === false
                )}
              />
            )}

            {fetched && (
              <IndicatorExplanationUpdateSideBar
                saving={saving}
                isUpdatingExplanation={isUpdatingExplanation}
                explanations={explanations}
                explanationId={explanationId}
                onCancelUpdateExplanation={this.onCancelUpdateExplanation}
                handleUpdateExplanation={this.handleUpdateExplanation}
                onChangeExplanationFr={this.onChangeExplanationFr}
                onChangeExplanationEn={this.onChangeExplanationEn}
                onChangeExplanationNl={this.onChangeExplanationNl}
                selectedAccount={this.state.selectedAccount}
                onChangeSelectedAccount={this.onChangeSelectedAccount}
                indicators={indicatorsOptionsSelect}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  lng: state.params.lng,
  explanationsItems: state.indicatorsExplanation.items,
  fetching:
    state.indicatorsExplanation.fetching ||
    state.indicators.suggestions.fetching,
  fetched:
    state.indicatorsExplanation.fetched && state.indicators.suggestions.fetched,
  saving: state.indicatorsExplanation.saving,
  saved: state.indicatorsExplanation.saved,
  deleting: state.indicatorsExplanation.deleting,
  deleted: state.indicatorsExplanation.deleted,
  indicators: state.indicators.suggestions.items
});

export default connect(mapStateToProps)(IndicatorsExplanationPage);



// WEBPACK FOOTER //
// ./src/components/IndicatorsExplanation/IndicatorsExplanationPage.js